import type { ContentEntity, CreatorEntity } from "shared/schema";
import { getKeys, splitEntity } from "shelving";
import { ADD_LIST_ITEM } from "shared/api";
import { Loader, NOTICES } from "shared/react";
import { MEMBER_ADMIN_STATUS, getShortcutID } from "shared/schema";
import { callAPIWithNotice } from "../util/api.js";
import { DB } from "../util/db.js";
import { USER } from "../util/user.js";
import { useOptionalGroupContext } from "./GroupContext.js";
import { MemberGroupPicker } from "./GroupPicker.js";

export function AssignChallengePicker({ cid }: { cid: string }): React.ReactElement {
	const group = useOptionalGroupContext();
	return (
		<>
			<h2>Assign challenge</h2>
			<Loader>
				<MemberGroupPicker
					query={{ uid: USER.data.uid, status: getKeys(MEMBER_ADMIN_STATUS) }}
					onPick={async gid => {
						const item: ContentEntity = `challenge:${cid}`;
						const creator: CreatorEntity = `group:${gid}`;
						const shortcut = await DB.getItem("shortcut", getShortcutID(creator, "assigned"));
						if (shortcut) {
							const [type, lid] = splitEntity(shortcut.target);
							if (type === "list") return await callAPIWithNotice(ADD_LIST_ITEM, { id: lid, item });
						}
						NOTICES.error("Group has no assigned list");
					}}
					isPicked={gid => group?.id === gid}
				/>
			</Loader>
		</>
	);
}
